var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendemoji1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.192 64.5494C25.3767 59.7942 28.9648 55.269 31.266 52.9182C43.0196 40.9113 64.4342 52.5336 62.2796 64.5735C58.1322 64.5434 59.0382 64.2631 57.6313 60.9128C53.0485 49.9969 36.499 48.0222 30.6449 61.5432C29.1905 64.9023 30.18 64.5993 26.192 64.5494ZM64.4832 31.6147C62.7161 42.9927 51.0175 35.5818 54.5328 29.9568C56.3175 27.1017 55.7919 29.607 64.4832 31.6147ZM23.9852 31.642C26.404 31.0594 28.7321 29.8414 30.9508 29.2935C34.2098 28.4887 32.7993 28.1216 33.9382 29.9216C37.5731 35.6669 25.5068 42.91 23.9852 31.642ZM0.712186 51.9766C4.43299 73.3254 25.0751 92.3385 51.4765 87.8567C73.1601 84.1756 92.3764 63.4867 87.7834 36.8163C84.0888 15.3617 63.4242 -3.86849 36.9435 0.671211C15.1187 4.41291 -3.96581 25.1376 0.712186 51.9766Z",
    fill: "#F2B51E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendemoji1);
export default __webpack_public_path__ + "static/media/friendemoji1.9d93c87bbe4131c995a9d637b8a2bbf0.svg";
export { ForwardRef as ReactComponent };